(function () {
  if (customElements.get('sentire-quiz')) return;

  var CODE = { AZ: 'atograzu-ziedynai', IS: 'imbierinis-sausainis', JP: 'juodasis-perlas', PP: 'prancuzijos-paziba', PV: 'prasmatnus-vakaras', PT: 'pusu-takas', SG: 'safrano-gelmese', SE: 'saldi-elegancija', SL: 'sokis-liepsnose', ZJ: 'zidinio-jaukumas', ZP: 'ziemos-pasaka' };
  var KEYS = Object.keys(CODE).map(function (c) { return CODE[c]; });

  var SCENTS = {
    'atograzu-ziedynai': { name: 'ATOGRĄŽŲ ŽIEDYNAI', tags: 'Gėliškas · Vaisiškas · Romantiškas', text: 'Tau artimesni subtilūs, elegantiški ir gyvybingi aromatai. Vyšnios, rožės ir jazmino natos pereina į šiltą santalo ir vanilės pagrindą.', gift: 'gėliškus, vaisiškus ir romantiškus aromatus', notes: ['vyšnia', 'rožė', 'jazminas', 'santalas', 'vanilė'] },
    'imbierinis-sausainis': { name: 'IMBIERINIS SAUSAINIS', tags: 'Šiltas · Saldus · Prieskoninis', text: 'Tau artimi jaukūs, gurmaniški aromatai, kurie namus pripildo šilumos. Imbiero, kardamono, cinamono, vanilės ir tonka derinys primena lėtą vakarą namuose ir ką tik iškeptus imbierinius sausainius.', gift: 'šiltus ir jaukius aromatus', notes: ['apelsinas', 'imbieras', 'kardamonas', 'cinamonas', 'romas', 'vanilė', 'tonka'] },
    'juodasis-perlas': { name: 'JUODASIS PERLAS', tags: 'Sodrus · Medienos · Prabangus', text: 'Tavo skonis krypsta į charakteringus, nišinius aromatus. Bergamotę ir prieskonius čia keičia gintaras, muskusas, pačiulis ir agarmedis – tamsus ir rafinuotas derinys.', gift: 'sodrius, medienos ir prabangius aromatus', notes: ['bergamotė', 'juodieji pipirai', 'kuminas', 'kalendra', 'muskusas', 'gintaras', 'pačiulis', 'agarmedis'] },
    'prancuzijos-paziba': { name: 'PRANCŪZIJOS PAŽIBA', tags: 'Gaivus · Aromatinis · Elegantiškas', text: 'Tau patinka ramūs ir gaivesni aromatai, kurie neužgožia erdvės. Eukalipto, levandų ir aromatinių augalų natos susijungia su santalu ir baltuoju muskusu.', gift: 'gaivius ir elegantiškus aromatus', notes: ['ramunėlės', 'juodieji serbentai', 'eukaliptas', 'pelargonija', 'osmantas', 'levanda', 'santalas', 'muskusas'] },
    'prasmatnus-vakaras': { name: 'PRAŠMATNUS VAKARAS', tags: 'Sodrus · Vaisiškas · Romantiškas', text: 'Tavo kvapo profilis – elegantiškas ir šiek tiek paslaptingas. Vyšnia bei juodieji serbentai pereina į jazminą, tamsų gintarą, vanilę ir santalą.', gift: 'sodrius, vaisiškus ir romantiškus aromatus', notes: ['vyšnia', 'juodieji serbentai', 'jazminas', 'frankincensas', 'juodasis gintaras', 'vanilė', 'santalas'] },
    'pusu-takas': { name: 'PUŠŲ TAKAS', tags: 'Miško · Gaivus · Prieskoninis', text: 'Tave traukia gamta. Pušies, kėnio ir kadagio aromatus papildo obuoliai, gvazdikėliai, cinamonas ir lengvas vanilės saldumas.', gift: 'miško ir gaivius aromatus', notes: ['obuoliai', 'razinos', 'gvazdikėliai', 'juodoji pušis', 'kėnis', 'kadagys', 'vanilė', 'cinamonas'] },
    'safrano-gelmese': { name: 'ŠAFRANO GELMĖSE', tags: 'Šiltas · Prieskoninis · Rafinuotas', text: 'Tau patinka šilti kvapai, tačiau ieškai kažko įdomesnio nei klasikinė vanilė. Šafraną ir kardamoną papildo spanguolės, rudasis cukrus, cinamonas ir vanilė.', gift: 'šiltus ir rafinuotus prieskonių aromatus', notes: ['spanguolė', 'apelsino žievelė', 'šafranas', 'kardamonas', 'gvazdikėlis', 'rudasis cukrus', 'cinamonas', 'vanilė'] },
    'saldi-elegancija': { name: 'SALDI ELEGANCIJA', tags: 'Gėliškas · Medienos · Elegantiškas', text: 'Tavo skonis subtilus, tačiau ne nuobodus. Gėlišką hiacinto, narcizo ir jazmino pradžią papildo gilesnės santalo, agarmedžio ir muskuso natos.', gift: 'subtilius gėliškus ir elegantiškus aromatus', notes: ['hiacintas', 'narcizas', 'jazminas', 'gvajokas', 'agarmedis', 'santalas', 'muskusas'] },
    'sokis-liepsnose': { name: 'ŠOKIS LIEPSNOSE', tags: 'Dūminis · Medienos · Intensyvus', text: 'Tave traukia charakteringi kvapai. Pušies ir eglės natos susitinka su oda, kedru, medžio anglimi, gintaru ir smilkalais. Tai kvapas, kuris ne tiesiog papildo erdvę – jis kuria jos charakterį.', gift: 'dūminius ir intensyvius aromatus', notes: ['eglė', 'pušis', 'oda', 'muskato riešutas', 'kedras', 'medžio anglis', 'gintaras', 'smilkalai'] },
    'zidinio-jaukumas': { name: 'ŽIDINIO JAUKUMAS', tags: 'Šiltas · Medienos · Tamsus', text: 'Tau patinka gilūs, nišiniai ir mažiau saldūs aromatai. Kardamoną lydi santalas, agarmedis, oda ir pačiulis, o kompoziciją užbaigia gintaras bei dūminės natos.', gift: 'šiltus medienos ir tamsius aromatus', notes: ['kardamonas', 'kuminas', 'agarmedis', 'santalas', 'oda', 'pačiulis', 'degutas', 'gintaras'] },
    'ziemos-pasaka': { name: 'ŽIEMOS PASAKA', tags: 'Saldus · Cinamoninis · Jaukus', text: 'Tavo idealus kvapas – tas, kuris akimirksniu sukuria namų jaukumą. Cinamonas, kardamonas, gvazdikėliai ir vanilė kuria klasikinį šiltų prieskonių aromatą.', gift: 'saldžius cinamono ir jaukius aromatus', notes: ['gvazdikėliai', 'kardamonas', 'cinamonas', 'vanilė'] }
  };

  function opt(label, tag, s, hint) { return { label: label, tag: tag, s: s, hint: hint || '' }; }

  var QUESTIONS = [
    { id: 'atmosphere', title: 'Kokią atmosferą norėtum sukurti namuose?', options: [
      opt('Šiltą ir jaukią', 'šilta ir jauku', { IS: 3, ZP: 3, SG: 2, ZJ: 2, PT: 1 }),
      opt('Prabangią ir paslaptingą', 'prabanga ir paslaptis', { JP: 3, PV: 3, ZJ: 3, SL: 2, SG: 2 }),
      opt('Gaivią ir ramią', 'gaivu ir rami', { PP: 4, PT: 3, AZ: 2, SE: 1 }),
      opt('Romantišką ir elegantišką', 'romantika ir elegancija', { PV: 4, AZ: 3, SE: 3, PP: 2 }),
      opt('Tarsi pabėgčiau į gamtą', 'pabėgimas į gamtą', { PT: 4, SL: 3, PP: 2, ZJ: 1 })
    ] },
    { id: 'scent_world', title: 'Kuris kvapų pasaulis skamba labiausiai kaip Tu?', options: [
      opt('Vanilė, cinamonas ir saldūs prieskoniai', 'saldūs prieskoniai', { IS: 4, ZP: 4, SG: 3, PV: 2 }, 'Šilta · saldu · jauku'),
      opt('Santalas, gintaras ir tamsi mediena', 'tamsi mediena', { JP: 4, ZJ: 4, SL: 3, SE: 2 }, 'Sodru · prabangu · paslaptinga'),
      opt('Gėlės ir lengvas vaisių saldumas', 'gėlės ir vaisiai', { AZ: 4, SE: 4, PV: 3, PP: 2 }, 'Romantiška · subtilu · elegantiška'),
      opt('Pušys, eglės ir gaivus miškas', 'miško gaiva', { PT: 5, SL: 4, PP: 1 }, 'Natūralu · gaivu · žemiška'),
      opt('Žolelės, levandos ir aromatinė gaiva', 'aromatinė gaiva', { PP: 5, AZ: 2, SE: 2 }, 'Švaru · ramu · lengva')
    ] },
    { id: 'sweetness', title: 'Kiek saldumo norėtum jausti kvape?', options: [
      opt('Daug – dievinu saldžius kvapus', 'daug saldumo', { IS: 5, ZP: 4, SG: 4, PV: 3, SL: -2, ZJ: -2 }),
      opt('Truputį – saldumas turi būti subtilus', 'subtilus saldumas', { AZ: 3, PV: 3, SG: 3, PT: 2, SE: 2 }),
      opt('Beveik jokio – renkuosi gaivius ar medienos kvapus', 'be saldumo', { JP: 4, PP: 4, SL: 4, ZJ: 4, PT: 3, SE: 2, IS: -3, ZP: -3 }),
      opt('Nesvarbu – svarbiausia, kad kvapas būtų įdomus', 'įdomus kvapas', { ALL: 2 })
    ] },
    { id: 'evening', title: 'Įsivaizduok tobulą vakarą. Kur esi?', options: [
      opt('Po pledu su arbata ir knyga', 'vakaras po pledu', { ZJ: 5, IS: 4, ZP: 3, SG: 2 }),
      opt('Vakarienė, vynas ir pritemdyta šviesa', 'vakarienė prie žvakių', { PV: 5, JP: 4, SG: 3, AZ: 2 }),
      opt('SPA, tyla ir visiškas atsipalaidavimas', 'SPA ir tyla', { PP: 5, SE: 3, AZ: 2 }),
      opt('Namelis miške, židinys ir gamta už lango', 'namelis miške', { PT: 5, SL: 5, ZJ: 4 }),
      opt('Gražus viešbutis ar boutique restoranas', 'boutique vakaras', { JP: 5, SE: 4, PV: 4, SG: 3 })
    ] },
    { id: 'intensity', title: 'Kokio charakterio kvapus paprastai renkiesi?', options: [
      opt('Lengvus ir subtilius', 'lengvi kvapai', { PP: 4, AZ: 3, SE: 3, PT: 2, ZJ: -2, SL: -2 }),
      opt('Vidutinius – kad jaustųsi, bet neužgožtų', 'vidutinio stiprumo kvapai', { AZ: 3, PV: 3, SG: 3, PT: 3, IS: 3, ZP: 3 }),
      opt('Sodrius ir charakteringus', 'sodrūs kvapai', { JP: 5, SL: 5, ZJ: 5, PV: 4, SG: 3 }),
      opt('Nežinau – nustebinkite', 'staigmena', { ALL: 1 })
    ] },
    { id: 'association', title: 'Kuri iš šių asociacijų labiausiai traukia?', options: [
      opt('Ką tik iškepti sausainiai', 'ką tik iškepti sausainiai', { IS: 7, ZP: 4, SG: 2 }),
      opt('Prabangūs kvepalai', 'prabangūs kvepalai', { JP: 7, PV: 5, SE: 4, ZJ: 3 }),
      opt('Pušynas po lietaus', 'pušynas po lietaus', { PT: 8, SL: 4 }),
      opt('Deganti mediena ir židinys', 'deganti mediena ir židinys', { SL: 8, ZJ: 7, JP: 2 }),
      opt('Gėlės ir vasaros vakaras', 'gėlės ir vasaros vakaras', { AZ: 7, SE: 6, PP: 4 }),
      opt('Cinamonas ir Kalėdų rytas', 'cinamonas ir Kalėdų rytas', { ZP: 8, IS: 6, PT: 4, SG: 3 }),
      opt('Šafranas, prieskoniai ir kažkas egzotiško', 'šafranas ir egzotiški prieskoniai', { SG: 8, JP: 4, ZJ: 3 }),
      opt('Levandos ir ramus sekmadienio rytas', 'levandos ir ramus sekmadienio rytas', { PP: 8, SE: 3 })
    ] }
  ];

  function contribution(o) {
    var out = {};
    KEYS.forEach(function (k) { out[k] = o.s.ALL !== undefined ? o.s.ALL : 0; });
    Object.keys(o.s).forEach(function (c) { if (CODE[c]) out[CODE[c]] = o.s[c]; });
    return out;
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>'"`]/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('en-IE', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return (cents / 100) + ' ' + cur;
    }
  }

  function track(name, params) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function' && !window.google_tag_manager) window.gtag('event', name, params);
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, params);
    } catch (e) {}
  }

  function btn(label, attrs, style, disabled) {
    return "<button type='button' class='button button--" + (style || 'primary') + " button--lg' is='hover-button' " + attrs + (disabled ? " disabled aria-disabled='true'" : '') + "><span class='btn-fill' data-fill></span><span class='btn-text'>" + label + "</span></button>";
  }

  class SentireQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.state = { answers: [], index: 0, size: 'small', color: 'black', gift: false };
      this.result = null;
      this.products = {};
      var data = this.querySelector('[data-sq-products]');
      try { this.products = JSON.parse(data.textContent); } catch (e) {}
      this.screens = {
        intro: this.querySelector('[data-sq-screen=intro]'),
        question: this.querySelector('[data-sq-screen=question]'),
        result: this.querySelector('[data-sq-screen=result]')
      };
      this.addEventListener('click', this.onClick.bind(this));
    }

    show(name) {
      var self = this;
      Object.keys(this.screens).forEach(function (k) { self.screens[k].hidden = k !== name; });
      var rect = this.getBoundingClientRect();
      if (rect.top < 0) window.scrollTo({ top: window.scrollY + rect.top - 96, behavior: 'smooth' });
    }

    onClick(e) {
      var link = e.target.closest('a[data-sq-link]');
      if (link) track('quiz_product_clicked', { product: link.getAttribute('data-sq-link') });
      var el = e.target.closest('[data-sq-action]');
      if (!el || el.disabled) return;
      var action = el.getAttribute('data-sq-action');
      if (action === 'start') this.start();
      else if (action === 'back') this.back();
      else if (action === 'answer') this.answer(parseInt(el.getAttribute('data-index'), 10));
      else if (action === 'restart') this.restart();
      else if (action === 'size' || action === 'color' || action === 'gift') this.toggle(action, el);
      else if (action === 'add') this.addOne(el);
      else if (action === 'bundle') this.addBundle(el);
    }

    start() {
      track('quiz_started');
      this.showQuestion(0);
      this.show('question');
    }

    back() {
      if (this.state.index === 0) {
        this.show('intro');
        return;
      }
      this.showQuestion(this.state.index - 1);
    }

    restart() {
      this.state = { answers: [], index: 0, size: 'small', color: 'black', gift: false };
      this.result = null;
      this.show('intro');
    }

    showQuestion(i) {
      var q = QUESTIONS[i];
      var chosen = this.state.answers[i];
      var cards = q.id === 'scent_world';
      this.state.index = i;
      this.querySelector('[data-sq-count]').textContent = (i + 1) + ' / ' + QUESTIONS.length;
      this.querySelector('[data-sq-bar]').style.setProperty('--sq-progress', ((i + 1) / QUESTIONS.length * 100) + '%');
      var title = this.querySelector('[data-sq-question]');
      title.textContent = q.title;
      var box = this.querySelector('[data-sq-options]');
      box.className = 'sq__options' + (cards ? ' sq__options--cards' : '');
      box.innerHTML = q.options.map(function (o, n) {
        return "<button type='button' class='sq__option" + (cards ? ' sq__option--card' : '') + "' role='radio' aria-checked='" + (chosen === n) + "' data-sq-action='answer' data-index='" + n + "'><span class='sq__option-title'>" + esc(o.label) + "</span>" + (o.hint ? "<span class='sq__option-hint'>" + esc(o.hint) + "</span>" : '') + "</button>";
      }).join('');
      title.focus({ preventScroll: true });
    }

    answer(n) {
      var i = this.state.index;
      var q = QUESTIONS[i];
      this.state.answers[i] = n;
      track('quiz_question_answered', { question_id: q.id, answer_id: String.fromCharCode(97 + n) });
      this.querySelectorAll('[data-sq-options] .sq__option').forEach(function (b, k) { b.setAttribute('aria-checked', String(k === n)); });
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (i < QUESTIONS.length - 1) this.showQuestion(i + 1);
        else this.finish();
      }, 260);
    }

    compute() {
      var totals = {};
      var per = [];
      var max = 0;
      KEYS.forEach(function (k) { totals[k] = 0; });
      this.state.answers.forEach(function (ai, qi) {
        var c = contribution(QUESTIONS[qi].options[ai]);
        var best = 0;
        per[qi] = c;
        KEYS.forEach(function (k) {
          totals[k] += c[k];
          if (c[k] > best) best = c[k];
        });
        max += best;
      });
      function tie(a, b) {
        return (per[5][b] - per[5][a]) || (per[1][b] - per[1][a]) || (per[2][b] - per[2][a]);
      }
      var ranked = KEYS.slice().sort(function (a, b) { return (totals[b] - totals[a]) || tie(a, b); });
      var dual = totals[ranked[0]] === totals[ranked[1]] && tie(ranked[0], ranked[1]) === 0;
      return { ranked: ranked, totals: totals, dual: dual, ratio: max > 0 ? totals[ranked[0]] / max : 0 };
    }

    finish() {
      this.result = this.compute();
      this.state.size = 'small';
      this.state.color = 'black';
      this.state.gift = false;
      var r = this.result.ranked;
      track('quiz_completed', { result_product: r[0], second_product: r[1], third_product: r[2] });
      this.renderResult();
      this.show('result');
    }

    pick(key, size, color) {
      var p = this.products[key];
      if (!p) return null;
      if (size === 'small') return p.small || null;
      var l = p.large || {};
      return color === 'white' ? (l.white || l.black || null) : (l.black || l.white || null);
    }

    matchLabel() {
      var r = this.result.ratio;
      if (r >= 0.8) return 'Puikus atitikimas';
      if (r >= 0.6) return 'Labai geras atitikimas';
      return 'Galimas atradimas';
    }

    why() {
      var a = this.state.answers;
      var t = function (qi) { return QUESTIONS[qi].options[a[qi]].tag; };
      return 'Pagal tavo atsakymus – ' + t(0) + ', ' + t(1) + ' ir ' + t(5) + ' – šis kvapas tau tinka geriausiai.';
    }

    card(key, tag) {
      var s = SCENTS[key];
      var p = this.pick(key, 'small');
      var url = p && p.url ? p.url : '#';
      var off = !p || !p.available;
      return "<article class='sq__card'><div class='sq__card-media'>" + (p && p.image ? "<img src='" + esc(p.image) + "' alt='" + esc(s.name) + "' width='300' height='300' loading='lazy'>" : '') + "</div><div class='sq__card-body'><span class='sq__card-tag'>" + esc(tag) + "</span><h3 class='sq__card-name heading'>" + esc(s.name) + "</h3><p class='sq__card-tags'>" + esc(s.tags) + "</p><div class='sq__card-actions'><button type='button' class='sq__mini' data-sq-action='add' data-key='" + key + "' data-size='small'" + (off ? ' disabled' : '') + ">" + (p && p.available ? 'Išbandyti 120 ml – ' + esc(p.priceText) : 'Šiuo metu nėra') + "</button><a class='sq__link' href='" + esc(url) + "' data-sq-link='" + key + "'>Peržiūrėti</a></div></div></article>";
    }

    renderResult() {
      var r = this.result;
      var self = this;
      var alts = r.dual ? [r.ranked[2]] : [r.ranked[1], r.ranked[2]];
      var tags = r.dual ? ['Jei norisi šiek tiek kitokio'] : ['Tau taip pat tinka', 'Jei norisi šiek tiek kitokio'];
      var top3 = r.ranked.slice(0, 3);
      var items = top3.map(function (k) { return self.pick(k, 'small'); }).filter(function (p) { return p && p.available; });
      var total = items.reduce(function (n, p) { return n + p.price; }, 0);
      var html = "<p class='sq__error' role='alert' data-sq-error hidden></p><div data-sq-main></div>";
      html += "<section class='sq__section'><h2 class='heading title-sm'>Tau taip pat gali patikti</h2><div class='sq__grid'>" + alts.map(function (k, n) { return self.card(k, tags[n]); }).join('') + "</div></section>";
      if (items.length > 1) {
        html += "<section class='sq__bundle'><h2 class='heading title-sm'>Negali išsirinkti?</h2><p class='sq__text'>Išbandyk visus " + items.length + " rekomenduotus 120 ml kvapus ir pasirink savo mėgstamiausią.</p>" + btn('Išbandyti visus ' + items.length + ' – ' + money(total), "data-sq-action='bundle' data-keys='" + top3.join(',') + "'") + "</section>";
      }
      html += "<div class='sq__restart'><button type='button' class='sq__link' data-sq-action='restart'>Atlikti testą iš naujo</button></div>";
      this.screens.result.innerHTML = html;
      this.renderMain();
    }

    dualHtml() {
      var r = this.result;
      var a = r.ranked[0];
      var b = r.ranked[1];
      var items = [this.pick(a, 'small'), this.pick(b, 'small')].filter(function (p) { return p && p.available; });
      var total = items.reduce(function (n, p) { return n + p.price; }, 0);
      return "<div class='sq__section'><div class='sq__dual-head'><p class='sq__eyebrow'>Tavo Sentire kvapai</p><h2 class='heading title-lg tracking-heading'>Tau tinka du kvapai</h2><p class='sq__text'>Panašu, kad tavo kvapo profilis balansuoja tarp dviejų pasaulių.</p></div><div class='sq__grid'>" + this.card(a, 'Tavo kvapas') + this.card(b, 'Tavo kvapas') + "</div><div class='sq__actions'>" + btn('Išbandyti abu po 120 ml – ' + money(total), "data-sq-action='bundle' data-keys='" + a + ',' + b + "'", 'primary', items.length < 2) + "</div></div>";
    }

    renderMain() {
      var host = this.querySelector('[data-sq-main]');
      var r = this.result;
      var st = this.state;
      if (r.dual) {
        host.innerHTML = this.dualHtml();
        return;
      }
      var key = r.ranked[0];
      var s = SCENTS[key];
      var small = this.pick(key, 'small');
      var large = this.pick(key, 'large', st.color);
      var cur = st.size === 'large' && large ? large : small;
      var img = (cur && cur.image) || (small && small.image) || (large && large.image) || '';
      var p = this.products[key] || {};
      var l = p.large || {};
      var chip = function (action, value, label, pressed, focus) {
        return "<button type='button' class='sq__chip' aria-pressed='" + pressed + "' data-sq-action='" + action + "' data-value='" + value + "' data-sq-focus='" + focus + "'>" + label + "</button>";
      };
      var groups = "<div class='sq__group'><span class='sq__label'>Kam renkiesi?</span><div class='sq__seg'>" + chip('gift', 'self', 'Sau', !st.gift, 'gift-self') + chip('gift', 'gift', 'Dovanai', st.gift, 'gift-gift') + "</div></div>";
      if (st.gift) {
        groups += "<p class='sq__why'>Puikus pasirinkimas dovanai žmogui, mėgstančiam " + esc(s.gift) + ". <a class='sq__link' href='/collections/dekoratyviniai-degtukai'>Pridėk dekoratyvinių degtukų</a></p>";
      }
      if (small && large) {
        groups += "<div class='sq__group'><span class='sq__label'>Dydis</span><div class='sq__seg'>" + chip('size', 'small', '120 ml · ' + esc(small.priceText), st.size === 'small', 'size-small') + chip('size', 'large', '300 ml · ' + esc(large.priceText), st.size === 'large', 'size-large') + "</div></div>";
      }
      if (st.size === 'large' && l.black && l.white) {
        groups += "<div class='sq__group'><span class='sq__label'>Indo spalva</span><div class='sq__seg'>" + chip('color', 'black', 'Juoda', st.color === 'black', 'color-black') + chip('color', 'white', 'Balta', st.color === 'white', 'color-white') + "</div></div>";
      }
      var label = (st.gift ? 'Pasirinkti dovanai' : 'Įdėti į krepšelį') + (cur ? ' – ' + esc(cur.priceText) : '');
      var off = !cur || !cur.available;
      var cta = btn(off ? 'Šiuo metu nėra' : label, "data-sq-action='add' data-key='" + key + "' data-size='" + st.size + "'", 'primary', off);
      var view = cur && cur.url ? "<a class='sq__link' href='" + esc(cur.url) + "' data-sq-link='" + key + "'>Peržiūrėti produktą</a>" : '';
      host.innerHTML = "<div class='sq__main'><div class='sq__media'>" + (img ? "<img src='" + esc(img) + "' alt='" + esc(s.name) + "' width='900' height='1125'>" : '') + "</div><div class='sq__body'><p class='sq__eyebrow'>Tavo Sentire kvapas</p><span class='sq__badge'>" + esc(this.matchLabel()) + "</span><h2 class='heading title-lg tracking-heading'>" + esc(s.name) + "</h2><p class='sq__tags'>" + esc(s.tags) + "</p><p class='sq__text'>" + esc(s.text) + "</p><p class='sq__why'>" + esc(this.why()) + "</p><div class='sq__group'><span class='sq__label'>Kvapo natos</span><ul class='sq__notes'>" + s.notes.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + "</ul></div>" + groups + "<div class='sq__actions'>" + cta + view + "</div></div></div>";
    }

    toggle(action, el) {
      var v = el.getAttribute('data-value');
      if (action === 'gift') this.state.gift = v === 'gift';
      else if (action === 'size') this.state.size = v;
      else this.state.color = v;
      var f = el.getAttribute('data-sq-focus');
      this.renderMain();
      var t = f && this.querySelector('[data-sq-focus=' + f + ']');
      if (t) t.focus({ preventScroll: true });
    }

    addOne(el) {
      var key = el.getAttribute('data-key');
      var size = el.getAttribute('data-size');
      var p = this.pick(key, size, this.state.color);
      if (!p) return;
      track('quiz_add_to_cart', { result_product: key, size: size === 'large' ? '300ml' : '120ml', gift: this.state.gift });
      this.addItems([{ id: p.id, quantity: 1 }], el);
    }

    addBundle(el) {
      var self = this;
      var keys = el.getAttribute('data-keys').split(',');
      var items = keys.map(function (k) { return self.pick(k, 'small'); }).filter(function (p) { return p && p.available; }).map(function (p) { return { id: p.id, quantity: 1 }; });
      track('quiz_bundle_add_to_cart', { products: keys.join(','), count: items.length });
      this.addItems(items, el);
    }

    showError(message) {
      var el = this.querySelector('[data-sq-error]');
      if (!el) return;
      el.textContent = message || '';
      el.hidden = !message;
    }

    addItems(items, button) {
      if (!items.length) return;
      var t = window.theme || {};
      var routes = t.routes || {};
      var url = routes.cart_add_url || '/cart/add.js';
      var fetchConfig = t.utils && t.utils.fetchConfig ? t.utils.fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var body = JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname });
      this.showError('');
      if (button.hasAttribute('aria-busy')) return;
      button.setAttribute('aria-busy', 'true');
      fetch(url, Object.assign({}, fetchConfig, { body: body }))
        .then(function (response) { return response.json(); })
        .then(function (state) {
          if (state.status) throw new Error(state.description || 'Nepavyko pridėti į krepšelį');
          if (t.settings && t.settings.cartType === 'page') {
            window.location.href = '/cart';
            return null;
          }
          var cartConfig = t.utils && t.utils.fetchConfig ? t.utils.fetchConfig('json', 'GET') : { headers: { Accept: 'application/json' } };
          return fetch(routes.cart_url || '/cart.js', cartConfig).then(function (response) { return response.json(); }).then(function (cart) {
            cart.sections = state.sections;
            if (t.pubsub) t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sentire-quiz', cart: cart });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') drawer.show(button);
            else window.location.href = '/cart';
          });
        })
        .catch((error) => { this.showError(error.message || 'Nepavyko pridėti į krepšelį'); })
        .finally(function () { button.removeAttribute('aria-busy'); });
    }
  }

  customElements.define('sentire-quiz', SentireQuiz);
})();
